import { ICompany } from "./company";
import { IProfile } from "./profile";
import { ITeam } from "./team";

export enum AssessmentStatus {
  WAITING = 'waiting',
  DONE = 'done',
  GENERATED = 'generated'
}

export enum Profile {
  PROFILE1,
  PROFILE2,
  PROFILE3,
  PROFILE4
}

export type Profiles = Lowercase<keyof typeof Profile>;

export interface ProfileData {
  id: Profiles;
  name: string;
  letter: string;
  type1: number;
  type2: number;
  intensity: number;
}

export interface SituationalIndex {
  id: string;
  name: string;
  inner: number;
  intensityName: string;
  text: string;
}

export interface IAssessmentResults {
  dominantProfiles: {
    short: string;
    extended: string;
  };
  profilesChartData: ProfileData[];
  situationalIndexChartData: SituationalIndex[];
  isolatedProfilesChartData: {
    id: Profiles;
    name: string;
    inner: number;
    environment: number;
    flexibility: number;
  }[];
  leadershipProfilesChartData: {
    id: Profiles;
    name: string;
    inner: number;
    environment: number;
    flexibility: number;
  }[];
  competencesChartData: {
    id: string;
    name: string;
    primary: Profiles;
    secondary: Profiles;
    inner: number;
    environment: number;
    text: string;
    profile1: number;
    profile2: number;
    profile3: number;
    profile4: number;
  }[];
  talentsChartData: {
    inner: string;
    env: string;
  };
  talents: {
    id: string;
    name: string;
    text: string;
    position: string;
    inner: number;
    environment: number;
  }[];

  error: boolean;

  // if error
  status?: string
  message?: string
}


export interface IAssessment {
  id?: number;
  created_at?: string;
  updated_at?: string;
  deleted_at?: string;
  status?: AssessmentStatus;
  report_id: number;
  api?: Record<string, any>;
  hash?: string;
  metadata?: Record<string, any>;
  team_id: number;
  profile_id?: number;
  company_id?: number;
  company?: ICompany;
  client_can_unlock?: boolean;
  role?: string;
  profile?: IProfile;
  team?: ITeam
  key?: string;
  results?: IAssessmentResults;
}

export interface IAssessmentReport {
  id?: number;
  createdAt?: Date;
  updatedAt?: Date;
  deletedAt: Date;
  active: boolean;
  name: string;
  version: string;
  credits: number;
  api: any;
  hash: string;
  premiumCredits: number;
}